module.exports = __webpack_public_path__ + "img/small-1.917a9e5b.webp";